import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
  selector: 'app-custom-action-cell',
  templateUrl: './custom-action-cell.component.html',
  styleUrls: ['./custom-action-cell.component.scss'],
})
export class CustomActionCellComponent implements ICellRendererAngularComp {

  params: any

  constructor(private readonly cdr: ChangeDetectorRef) { }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params  
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params
    this.cdr.detectChanges()
    return true;
  }

  handleAction(event, action: string) {
    event = Array.isArray(event) ? event[0] : event 
    event.stopPropagation();
    event.preventDefault(); 
    this.params.onAction(action, this.params)
  }
}
